import { InputEntity } from "../../..";

export class TransmedRegistrationPaymentProofInput extends InputEntity {
  public constructor(public proof: File) {
    super();
  }
}

export class TransmedRegistrationPaymentProofValidationInput extends InputEntity {
  public constructor(
    public valid: boolean,
    public message: string | null = null
  ) {
    super();
  }
}
